import { useAuthStore } from '@/features/auth/store';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/auth')({
  beforeLoad: async () => {
    await useAuthStore.getState().actions.checkAuth();

    const { isAuthenticated } = useAuthStore.getState();

    if (isAuthenticated) {
      throw redirect({
        to: '/projects',
        search: {
          redirectTo: location.pathname,
        },
      });
    }
  },
  component: AuthLayoutComponent,
});

function AuthLayoutComponent() {
  return <Outlet />;
}
